import { AxiosResponse } from 'axios';
import { API_BASE_URL, DEFAULT_PAGE_SIZE } from "../core/config";
import { httpConfig } from "../core/config/http";
import { url } from '../core/helpers/string';
import { Repository } from '../core/repositories/Repository';
import PeerPaymentCriteria from '../Criterias/PeerPaymentCriteria';
import PreviewShipment1688Interface from '../Interface/PreviewShipment1688Interface';
import PreviewShipmentAndPeerPaymentInterface from '../Interface/PreviewShipmentAndPeerPaymentInterface';
import ShipmentAndPayOrderInterface from '../Interface/ShipmentAndPayInterface';


export class CartRepository extends Repository {
    constructor() {
        super(httpConfig);
        this.setBaseURL(url(API_BASE_URL, ''));
    }

    public getProductCart = (filter:any): Promise<any> => {
        let limit = filter && filter.size? filter.size:DEFAULT_PAGE_SIZE;
        let offset=filter && filter.page? filter.page*limit:0;
        return this.http
            .get(`carts`, {params:{...filter, offset, limit, sort:'timestamp:desc'}})
            .then((response: AxiosResponse<any>) => {
                return response;
            });
    }
    public deleteMerchant = (merchantId: any) : Promise<any> => {
        return this.http
            .delete(`carts/merchants/${merchantId}`);
    }

    public deleteSku = (id: any) : Promise<any> => {
        return this.http
            .delete(`carts/skus/${id}`);
    }

    public updateQuantitySku = (skuId: any, value:number):Promise<any> => {
        return this.http
            .post(`carts/skus/${skuId}/update-quantity`,{quantity: value}).then((response: AxiosResponse<any>) => {
                return response.data;
            });
    }

    public updateSku = (skuId: any,body:any):Promise<any> => {
        return this.http
            .patch(`carts/skus/${skuId}`,body).then((response: AxiosResponse<any>) => {
                return response.data;
            });
    }

    public createDraftOrder = (body: any):Promise<any> => {
        return this.http
            .post(`draft-orders`,body).then((response: AxiosResponse<any>) => {
                return response.data;
            });
    }
    public updateDraftOrder = (draftId: string,body: any):Promise<any> => {
        return this.http
            .post(`draft-orders/${draftId}/items`,body).then((response: AxiosResponse<any>) => {
                return response.data;
            });
    }
    public getAddressList = ():Promise<any> => {
        return this.http.get(`addresses`).then((response:AxiosResponse<any>) => {
           return response.data;
        });
    }

    public createAddress = (body:any): Promise<any>=> {
        return this.http
            .post(`/addresses`,body).then((res:AxiosResponse) => {
                return res;
            })
    }
    public updateAddress = (id: any, body:any): Promise<any>=> {
        return this.http
            .patch(`/addresses/${id}`,body).then((res:AxiosResponse) => {
                return res;
            })
    }

    public deleteAddress = (id:string) : Promise<any> => {
        return this.http.delete(`/addresses/${id}`).then((response: AxiosResponse) => {
            return response;
        })
    }

    public createOrderMultiple = (commands:any) : Promise<any> => {
        return this.http.post(`/orders/create-list`,{commands: commands}).then((response:AxiosResponse) => {
            return response;
        })
    }

    public createOrderOneShop = (body:any) : Promise<any> => {
        return this.http.post(`/orders`,body).then((response:AxiosResponse) => {
            return response;
        })
    }

    public checkAddressSupport = (body:any): Promise<any>=> {
        return this.http
            .post(`/addresses/provider-support`,body).then((res:AxiosResponse) => {
                return res;
            })
    }
    public getFavoriteServices = ():Promise<any> => {
        return this.http.get(`/customer-services`).then((response:AxiosResponse<any>) => {
            return response.data;
        });
    }
    public updateFavoriteServices = (body: any):Promise<any> => {
        return this.http.post(`/customer-services/favorites`, body).then((response:AxiosResponse<any>) => {
            return response.data;
        });
    }

    public requestForPayment = (body: any) : Promise<any> => {
        return this.http.post(`/payment-requests/payment`,{...body, paymentProvider: "DIOR"}).then((response:AxiosResponse) => {
            return response.data;
        })
    }
   

    public getPaymentRequests = (): Promise<any> => {
		return this.http.get('/payment-requests').then((response: AxiosResponse<any>) => {
			return response.data
		})
	}

    public createShipmentAndOrderPreview = (body: any) : Promise<any> => {
        return this.http.post(`/`,{...body}).then((response:AxiosResponse) => {
            return response.data;
        })
    }

    public createShipmentAndOrder = (body: any) : Promise<any> => {
        return this.http.post(`/`,{...body}).then((response:AxiosResponse) => {
            return response.data;
        })
    }


    public getPartnerOfShipmentOrOrder = (type?: string, linkProvider?: string) : Promise<any> => {
        return this.http.get(`/connections/account-balance/providers`, {params: {type, linkProvider}}).then((response:AxiosResponse) => {
            return response.data;
        })
    }

    public getAccountsForBuy = (peerPaymentProvider: string, providerUsername: string) : Promise<any> => {
        return this.http.get(`/purchasing-accounts`, {params: { marketplace: '1688', peerPaymentProvider, providerUsername }}).then((response:AxiosResponse) => {
            return response.data;
        })
    }

    public getExchangeRate = (peerPaymentProvider: string, providerUsername: string, purchasingAccount: string) : Promise<any> => {
        return this.http.get(`/peer-payments/exchange-rates`, {params: {offset: 0, limit: 1000, marketplace: '1688', paymentMethodCode: 'alipay',purchasingAccount, peerPaymentProvider, providerUsername }}).then((response:AxiosResponse) => {
            return response.data;
        })
    }

    public previewShipment1688 = (body: PreviewShipmentAndPeerPaymentInterface) : Promise<any> => {
        return this.http.post(`/shipment-peer-payment/preview-shipment`,{...body}).then((response:AxiosResponse) => {
            return response.data;
        })
    }

    public createShipmentNot1688 = (body: PreviewShipment1688Interface) : Promise<any> => {
        return this.http.post(`/shipment-peer-payment/create-shipment`,{...body}).then((response:AxiosResponse) => {
            return response.data;
        })
    }

    public createShipmentAndPayOrder = (body: ShipmentAndPayOrderInterface) : Promise<any> => {
        return this.http.post(`/shipment-peer-payment/create-shipment-1688`,{...body}).then((response:AxiosResponse) => {
            return response.data;
        })
    }

    public getPeerPaymentFee = (body: PeerPaymentCriteria) : Promise<any> => {
        return this.http.post(`/shipment-peer-payment/payment-fee`, body).then((response:AxiosResponse) => {
            return response.data;
        })
    }

    
}
export const cartRepository: CartRepository = new CartRepository();
